import { render, staticRenderFns } from "./skeleton-wrapper.vue?vue&type=template&id=a450a8ae&"
import script from "./skeleton-wrapper.vue?vue&type=script&lang=js&"
export * from "./skeleton-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports